<template>
  <p v-if="!model.$disabled" :class="{ 'text-bold': boldLabel }">{{ model.$title }}</p>

  <w-select
    variant="outlined"
    :model="model.Wojewodztwo"
    :options="wojOptions"
    @change="onWojChange"
  />

  <w-select variant="outlined" :model="model.Powiat" :options="powOptions" @change="onPowChange" />

  <w-select variant="outlined" :model="model.Gmina" :options="gmiOptions" @change="onGmiChange" />

  <w-row :gap="5">
    <w-col :size="8">
      <w-input variant="outlined" :model="model.Miejscowosc" />
    </w-col>

    <w-col :size="4">
      <w-input variant="outlined" :model="model.KodPocztowy" />
    </w-col>
  </w-row>

  <w-input variant="outlined" :model="model.Poczta" />

  <w-input variant="outlined" :model="model.Ulica" />

  <w-row :gap="5">
    <w-col :size="4">
      <w-input variant="outlined" :model="model.Nr" />
    </w-col>

    <w-col :size="4">
      <w-input variant="outlined" :model="model.NumerLokalu" />
    </w-col>
  </w-row>
</template>

<script setup lang="ts">
import type { SelectOption } from '@witkac/vue3-components';
import { computed, ref } from 'vue';

import type { AddressSchema } from '../../shared/addressSchema';

const props = defineProps<{
  /**
   * Adres do wyświetlenia
   */
  model: AddressSchema;

  /**
   * Czy wyświetlać pogrubioną etykietę
   */
  boldLabel?: boolean;

  /**
   * Ograniczone województwa
   */
  woj?: string[];
}>();

const emit = defineEmits<{
  (e: 'woj-changed', model: AddressSchema, pow: string[], gmi: string[]): void;
  (e: 'pow-changed', model: AddressSchema, pow: string[], gmi: string[]): void;
  (e: 'gmi-changed', model: AddressSchema, pow: string[], gmi: string[]): void;
}>();

const pow = ref<string[]>([]);
const gmi = ref<string[]>([]);

const onWojChange = () => {
  emit('woj-changed', props.model, pow.value, gmi.value);
};

const onPowChange = () => {
  emit('pow-changed', props.model, pow.value, gmi.value);
};

const onGmiChange = () => {
  emit('gmi-changed', props.model, pow.value, gmi.value);
};

const wojOptions = computed<SelectOption[]>(
  () =>
    props.woj?.map((w) => ({
      value: w,
      text: w,
    })) || [],
);

const powOptions = computed<SelectOption[]>(() =>
  pow.value.map((p) => ({
    value: p,
    text: p,
  })),
);

const gmiOptions = computed<SelectOption[]>(() =>
  gmi.value.map((g) => ({
    value: g,
    text: g,
  })),
);

onWojChange();
onPowChange();
</script>

<style scoped>
.text-bold {
  font-weight: bold;
}
</style>
